import React from 'react';
export function AlertBanner() {
  return <section className="w-full bg-[#f9f8f4] px-4 md:px-8 pb-16" data-id="element-18">
      <div className="max-w-[900px] mx-auto" data-id="element-19">
        <div className="rounded-2xl px-8 py-10 md:px-12 md:py-12 text-center" style={{
        backgroundColor: '#fef9e7',
        border: '3px dashed #e6a817'
      }} data-id="element-20">
          <p className="font-['Playfair_Display',_serif] text-[#c0392b] font-bold text-xl md:text-2xl lg:text-[28px] uppercase leading-snug mb-5" data-id="element-21">
            ⚠️ ¿Harta de cocinar y darle la comida a tu familia (por no saber
            vender)?
          </p>
          <p className="font-['Montserrat',_sans-serif] text-[#2d6a2e] text-lg md:text-xl lg:text-[22px] leading-relaxed" data-id="element-22">
            Esto no es teoría ni "motivación barata". Es un Sistema de Negocio
            Completo (Recetas + Costos + Ventas) diseñado para que tu cocina
            funcione como una empresa.
          </p>
        </div>
      </div>
    </section>;
}